module.exports = __webpack_public_path__ + "images/backgrounds/purple-blur.3a02eab932195316109b.png";